// Adults

export const increaseAdults = () => ({
  type: 'increaseAdults',
});

export const decreaseAdults = () => ({
  type: 'decreaseAdults',
});

export const setAdults = (content) => ({
  type: 'setAdults',
  payload: content,
});

export const setKids = (content) => ({
  type: 'setKids',
  payload: content,
});

// Date
export const changeDepartureDate = (content) => ({
  type: 'changeDepartureDate',
  payload: content,
});

export const changeCalendarSelected = (content) => ({
  type: 'changeCalendarSelected',
  payload: content,
});

// Destination
export const changeDestination = (content) => ({
  type: 'changeDestination',
  payload: content,
});

export const changeSelectedResorts = (content) => ({
  type: 'changeSelectedResorts',
  payload: content,
});

export const changeResortOptions = (content) => ({
  type: 'changeResortOptions',
  payload: content,
});

export const changeSearchInputValue = (content) => ({
  type: 'changeSearchInputValue',
  payload: content,
});

// Depature
export const changeDepatureCity = (content) => ({
  type: 'changeDepatureCity',
  payload: content,
});

export const changeCityFrom = (content) => ({
  type: 'changeCityFrom',
  payload: content,
});

// Search form popup  visibility
export const changePopupVisibility = (content) => ({
  type: 'changePopupVisibility',
  payload: content,
});

// Nights
export const increaseNightsFrom = {
  type: 'increaseNightsFrom',
};

export const decreaseNightsFrom = {
  type: 'decreaseNightsFrom',
};

export const setNightsFrom = (content) => ({
  type: 'setNightsFrom',
  payload: content,
});

export const setNightsTo = (content) => ({
  type: 'setNightsTo',
  payload: content,
});

export const selectionNightsFrom = (content) => ({
  type: 'selectionNightsFrom',
  payload: content,
});

export const selectionNightsTo = (content) => ({
  type: 'selectionNightsTo',
  payload: content,
});

export const changeUserAuthStatus = (content) => ({
  type: 'changeUserAuthStatus',
  payload: content,
});

// Search value
export const changeSearchResult = (content) => ({
  type: 'changeSearchResult',
  payload: content,
});

export const changeAvailableDays = (content) => ({
  type: 'changeAvailableDays',
  payload: content,
});

export const changeAvailableDaysKey = (content) => ({
  type: 'changeAvailableDaysKey',
  payload: content,
});

export const changeTabletFilterMenuVisibility = (content) => ({
  type: 'changeTabletFilterMenuVisibility',
  payload: content,
});

export const changeTimeIsUpVisibility = (content) => ({
  type: 'changeTimeIsUpVisibility',
  payload: content,
});

export const changeHotelDetailsFilterMenuVisibility = (content) => ({
  type: 'changeHotelDetailsFilterMenuVisibility',
  payload: content,
});

export const changeCharterOnly = (content) => ({
  type: 'changeCharterOnly',
  payload: content,
});

export const changeDestinationButton = (content) => ({
  type: 'changeDestinationButton',
  payload: content,
});

export const changeNightsButton = (content) => ({
  type: 'changeNightsButton',
  payload: content,
});

export const changeTouristsSearchText = (content) => ({
  type: 'changeTouristsSearchText',
  payload: content,
});

export const changeDatesSearchText = (content) => ({
  type: 'changeDatesSearchText',
  payload: content,
});

export const changeContactModalVisible = (content) => ({
  type: 'changeContactModalVisible',
  payload: content,
});

export const changeUserFirstLetter = (content) => ({
  type: 'changeUserFirstLetter',
  payload: content,
});

export const changeOtherToursCoords = (content) => ({
  type: 'changeOtherToursCoords',
  payload: content,
});

export const changeTouristsPopupVisible = (content) => ({
  type: 'changeTouristsPopupVisible',
  payload: content,
});
